<div  [@routerTransition]>
  <div class="col-sm-12" *ngIf='IsSetAccessRights'>
    <driverinfov3 [ActorCode]='ActorCode'
                    [CanEdit]='CanEditIdentities' [CanShow]='CanShowIdentities'
                    *ngIf="ActorCode >0"></driverinfov3>
  </div>
</div>
